import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route
  } from "react-router-dom";
import './App.css';
import Home from './Home';
import Login from './Login';
import Cadastro from './Cadastro';
import Cadastro2 from './Cadastro2';
import Inicio from './Inicio';
import Anuidade from './Anuidade';
import Carteira from './Carteira';
import Eventos from './Eventos';
import Formularios from './Formularios';
import Academias from './Academias';
import Foto from './Foto';
import Pedidos from './Pedidos';
import Dados from './Dados';
import Senha from './Senha';
import EsqueciSenha from './EsqueciSenha';


function App() {

    return (
        <Router>
            <Switch>
                <Route path="/login">
                    <Login />
                </Route>
                <Route path="/cadastro">
                    <Cadastro />
                </Route>
                <Route path="/cadastro2">
                    <Cadastro2 />
                </Route>
                <Route path="/inicio">
                    <Inicio />
                </Route>
                <Route path="/anuidade">
                    <Anuidade />
                </Route>
                <Route path="/carteira">
                    <Carteira />
                </Route>
                <Route path="/eventos">
                    <Eventos />
                </Route>
                <Route path="/formularios">
                    <Formularios />
                </Route>
                <Route path="/academias">
                    <Academias />
                </Route>
                <Route path="/foto">
                    <Foto />
                </Route>
                <Route path="/pedidos">
                    <Pedidos />
                </Route>
                <Route path="/dados">
                    <Dados />
                </Route>
                <Route path="/senha">
                    <Senha />
                </Route>
                <Route path="/esqueci-senha">
                    <EsqueciSenha />
                </Route>
                <Route path="/">
                    <Home />
                </Route>
            </Switch>
        </Router>
    );
}

export default App;
